import COUNTRY_ACTIONS from "../actions/CountriesActions";
import _ from "lodash";
import {CountrySortFields} from "../constants/CountriesActionConstants";
import SortDirection from "../../../common/constants/SortDirection";
import {listPageGlobalFilter} from "../../../common/utils/FilterFunctions";

const initialState = {
    all_countries: [],
    filtered_all_countries: [],
    countriesSortKey: CountrySortFields.COUNTRY_NAME,
    countriesSortDirection: SortDirection.ASC,
}

const countriesReducer = (state = initialState, action) => {
    switch (action.type) {

        case COUNTRY_ACTIONS.Types.COUNTRY_GLOBAL_SEARCH: {
            let newState = _.cloneDeep(state);
            newState.filtered_all_countries = listPageGlobalFilter(action.payload, newState.all_countries);

            return newState;
        }

        case COUNTRY_ACTIONS.Types.TOGGLE_COUNTRY_SORT: {
            let newState = _.cloneDeep(state);
            newState.countriesSortDirection = newState.countriesSortDirection === SortDirection.ASC
                ? SortDirection.DESC : SortDirection.ASC;
            if (newState.countriesSortDirection === SortDirection.ASC) {
                newState.filtered_all_countries = _.sortBy(newState.filtered_all_countries,
                    [s => s[action.payload].toString().toLowerCase()], [action.payload]);
            } else {
                newState.filtered_all_countries = _.sortBy(newState.filtered_all_countries,
                    [s => s[action.payload].toString().toLowerCase()], [action.payload]).reverse();
            }
            newState.countriesSortKey = action.payload;
            return newState;
        }

        case COUNTRY_ACTIONS.Types.LOAD_ALL_COUNTRIES: {
            let newState = _.cloneDeep(state);
            newState.all_countries = action.payload;
            newState.filtered_all_countries = action.payload;
            return newState;
        }

        default: return state
    }
}

export default countriesReducer;
